module.exports = __webpack_public_path__ + "static/img/mall-1.87c333fe.png";